export default (value: any) => {
  switch (value) {
    case '01/01/0001': return 'No Date';
    default: return value;
  }
};